import React from 'react'
import MaterialSymbol from '../material-symbol'

const Warning = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="warning" {...props} />
))

Warning.displayName = 'Warning'

export default Warning
